const NOTIFICATION_REQUEST_STORE = "NotificationRequestStore";

export const saveNotificationRequestStore = (data) => {
  window.localStorage.setItem(
    NOTIFICATION_REQUEST_STORE,
    JSON.stringify(data),
  );
};

export const getNotificationRequestStore = () => {
  try {
    if (!localStorage) return null;

    const data = window.localStorage.getItem(NOTIFICATION_REQUEST_STORE);

    if (!data) return null;

    return JSON.parse(data);
  } catch (error) {
    return null;
  }
};

export const removeNotificationRequestStore = () => {
  window.localStorage.removeItem(NOTIFICATION_REQUEST_STORE);
};
